import React from 'react';
import Helmet from 'react-helmet';

export const SchemaOrg = ({ product }) => {
  const variant = product.shopify_product.variants?.[0];
  const worstRating = product.reviews.sort((a, b) => a.rating - b.rating)[0].rating;
  const review = product.reviews.map(review => {
    return {
      '@type': 'Review',
      author: review.name,
      datePublished: review.date,
      reviewBody: review.text,
      name: review.title1,
      reviewRating: {
        '@type': 'Rating',
        bestRating: '5',
        ratingValue: review.rating,
        worstRating,
      },
    };
  });
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: product.average_customers_rating,
      reviewCount: product.reviews_count,
    },
    description: product.short_description,
    name: product.title,
    image: variant?.image || product.images[0].image.fluid.src,
    review,
  };
  if (variant) {
    schema.offers = {
      '@type': 'Offer',
      availability: product.out_of_stock ? 'OutOfStock' : 'InStock',
      price: variant.price,
      priceCurrency: 'USD',
    };
  }
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
